import { slicedToArray as _slicedToArray, defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { useRef, useState, useCallback, useEffect } from 'react';
import debounce from 'lodash/debounce.js';
import isNil from 'lodash/isNil.js';
import { i18n } from '../../i18n/index.js';
import { GetValidationPattern } from '../../utils/ValidationUtil.js';
import { formatClassName as _formatClassName } from '../../utils/formatClassName.js';

var useFormControl = function useFormControl(props) {
  var as = props.as,
      className = props.className,
      dataValue = props.dataValue,
      name = props.name,
      onValueChange = props.onValueChange,
      setError = props.setError,
      type = props.type,
      valueChangeDelay = props.valueChangeDelay,
      valueOverride = props.valueOverride;
  var input = useRef(null);
  var pattern = GetValidationPattern(type, props.pattern);

  var _useState = useState(dataValue),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var debouncedValueChange = debounce(function (value) {
    if (onValueChange) {
      onValueChange(_defineProperty({}, name, value));
    }
  }, valueChangeDelay, {
    leading: false,
    trailing: true
  });
  var onChange = useCallback(function (value, skipValueChange) {
    if (props.onChange) {
      props.onChange(value);
    }

    if (!skipValueChange) {
      debouncedValueChange(value);
    }

    setValue(value);
  }, [debouncedValueChange, props]);
  var onFormChange = useCallback(function (e) {
    onChange(e.currentTarget.value);
  }, [onChange]);
  var checkError = useCallback(function () {
    if (input) {
      var _input$current;

      var message = input !== null && input !== void 0 && (_input$current = input.current) !== null && _input$current !== void 0 && (_input$current = _input$current.validity) !== null && _input$current !== void 0 && _input$current.valueMissing ? i18n.t('This field is required') : null;

      if (!message && type && type.toLowerCase() === 'email') {
        var _pattern = new RegExp(GetValidationPattern(type, undefined));

        if (!_pattern.test(value)) {
          message = i18n.t('The email you entered is invalid');
        }
      }

      if (setError) {
        var _input$current2;

        setError(!(input !== null && input !== void 0 && (_input$current2 = input.current) !== null && _input$current2 !== void 0 && _input$current2.validity.valid), message);
      }
    }
  }, [setError, type, value]);
  var onBlur = useCallback(function (e) {
    var _e$currentTarget;

    if (props.onBlur) {
      props.onBlur(value);
    }

    checkError();
    if (!(e !== null && e !== void 0 && (_e$currentTarget = e.currentTarget) !== null && _e$currentTarget !== void 0 && _e$currentTarget.value) || e.currentTarget.value === dataValue) return;

    if (onValueChange) {
      onValueChange(_defineProperty({}, name, e.currentTarget.value));
    }

    debouncedValueChange.cancel();
  }, [checkError, dataValue, debouncedValueChange, name, onValueChange, props, value]);
  useEffect(function () {
    if (!isNil(dataValue) && (isNil(value) || valueOverride)) {
      setValue(dataValue);
    }
  }, [dataValue, value, valueOverride]);

  var newClassName = _formatClassName([className, {
    'p-r-10': as === 'textarea'
  }]);

  return {
    pattern: pattern,
    newClassName: newClassName,
    onBlur: onBlur,
    onFormChange: onFormChange,
    input: input,
    value: value
  };
};

export { useFormControl };